export const BREAK_SIGNAL = 'BREAK_SIGNAL'
